export const SHARED_META_ASDA = [
  {
    name: 'google-site-verification',
    content: 'iKt5zJKdvS2KtKpzsQGu-WmffxTYfgpiqh_ettsaF7c'
  },
  {
    property: 'og:site_name',
    content: 'Asda Online Doctor'
  },
  {
    property: 'og:type',
    content: 'article'
  },
  {
    name: 'twitter:site',
    content: ''
  },
  {
    name: 'twitter:card',
    content: 'summary'
  },
  {
    name: 'msapplication-TileColor',
    content: '#68A51C'
  },
  {
    name: 'msvalidate.01',
    content: 'DFA0EDE64C29F5E07C8C9F865B66ECA1'
  },
  {
    name: 'theme-color',
    content: '#68A51C'
  }
]
